import React from 'react';

import styled from 'styled-components';

import { NwButton } from '@components/Gui/NwButton';

import { useAgendaContext } from './AgendaContext';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const AgendaFooterContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;

    .agenda-footer-left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .agenda-footer-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
`;

const AgendaFooter = ({ onOpenSendAgendaDrawer, isContactApproved }) => {
    const {
        bookingSection,
        hideAvailableEvents,
        isLoadingAvailableEvents,
        isShowingAvailableEvents,
        loadAvailableEvents,
        previewMode,
        type,
    } = useAgendaContext();

    const getAgendaFooterContent = () => {
        return (
            <AgendaFooterContainer>
                {previewMode || (type && type.toLowerCase() !== 'model') ? null : type === 'model' ? (
                    <>
                        <div className="agenda-footer-left">&nbsp;</div>
                        <div className="agenda-footer-right">
                            <NwButton
                                ghost
                                icon={byPrefixAndName.fasl['share']}
                                size="small"
                                label="send agenda"
                                onClick={onOpenSendAgendaDrawer}
                            />
                            {isShowingAvailableEvents ? (
                                <NwButton
                                    ghost
                                    icon={byPrefixAndName.fasl['eye-slash']}
                                    solid
                                    size="small"
                                    label="hide available castings"
                                    onClick={hideAvailableEvents}
                                />
                            ) : (
                                <NwButton
                                    disabled={!isContactApproved}
                                    loading={isLoadingAvailableEvents}
                                    ghost
                                    icon={byPrefixAndName.fasl['user-plus']}
                                    solid
                                    size="small"
                                    label="see available castings"
                                    onClick={loadAvailableEvents}
                                />
                            )}
                            {/* </div> */}
                            {/* </Popover> */}
                        </div>
                    </>
                ) : (
                    //TODO: filters on general agenda view as in calendar
                    <></>
                )}
            </AgendaFooterContainer>
        );
    };

    if (bookingSection) {
        return <div className="calendar-fixed-footer">{getAgendaFooterContent()}</div>;
    } else {
        return getAgendaFooterContent();
    }
};

export default AgendaFooter;
